// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component__3aH4d","head":"index_head__2fEwk","text":"index_text__1plJh","Image":"index_Image__3ZnwM","div":"index_div__3c873","footer":"index_footer__2zNOS"};